<div class="flex flex-col h-full w-full bg-white gap-6 pb-6">
  <!-- Tab Bar -->
  <div class="flex flex-row gap-0 border-b border-bic-gray-200 px-6 pt-4">
    @for (tab of tabs; track tab) {
      <button
        (click)="switchTab(tab)"
        [class.border-b-2]="activeTab === tab"
        [class.border-bic-primary]="activeTab === tab"
        [class.font-semibold]="activeTab === tab"
        [class.text-bic-primary]="activeTab === tab"
        [class.text-gray-500]="activeTab !== tab"
        class="px-4 py-2 text-sm transition-colors">
        {{ tab === 'IDS' ? 'IDS-Regeln' : tab === 'HYBRID' ? 'Hybrid-Regelsets' : 'AI-Regelsets' }}
      </button>
    }
  </div>
  <!-- Selection Lists: Dual panel 50/50 split -->
  <div class="flex flex-row flex-1 w-full gap-6 px-6 overflow-hidden">
    <!-- LEFT: Available rules -->
    <div class="flex flex-col h-full w-1/2 gap-3 py-6 border-bic-gray-200 border rounded-lg overflow-hidden">
      <div class="flex flex-row w-full gap-4 px-6 justify-between items-center flex-shrink-0">
        <p class="text-gray text-sm font-medium">Verfügbare Prüfregeln:</p>
        <div class="flex flex-row w-fit gap-4">
          <bic-button (click)="addOrRemoveAllRules()" buttonType="white">Alle</bic-button>
        </div>
      </div>
      <div
        #availableRulesList="cdkDropList"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListConnectedTo]="selectedRulesList"
        [cdkDropListData]="availableRules"
        cdkDropList
        class="flex flex-col flex-grow min-h-0 w-full overflow-y-auto gap-3 py-1 px-6"
        id="availableRulesList">
        @if (availableRules.length === 0 && !loading) {
          <div class="flex h-full justify-center items-center">Alle Prüfregeln ausgewählt</div>
        } @else if (loading) {
          @for (i of [1, 2, 3, 4, 5]; track i) {
            <div class="flex flex-row shadow-full w-full rounded-lg p-4 flex-shrink-0 animate-pulse">
              <div class="flex flex-row justify-start items-center gap-4 w-full">
                <div class="w-5 h-5 bg-gray-200 rounded-full flex-shrink-0"></div>
                <div class="h-4 bg-gray-200 rounded-full flex-1 max-w-[60%]"></div>
              </div>
              <div class="h-5 w-16 bg-gray-200 rounded-full flex-shrink-0"></div>
            </div>
          }
        } @else {
          @for (rule of availableRules; track rule.id) {
            <div cdkDrag
                 class="flex flex-row shadow-full w-full rounded-lg justify-between items-center hover:cursor-grab p-4 flex-shrink-0">
              <div class="flex flex-row justify-start items-center gap-4 min-w-0">
                <button (click)="addRuleToSelected(rule)" class="flex-shrink-0">
                  <fa-icon [icon]="faPlusCircle" class="text-green"></fa-icon>
                </button>
                <div class="font-medium text-gray-700 text-sm truncate">{{ rule.name }}</div>
              </div>
              <div class="flex flex-row justify-end items-center gap-4 flex-shrink-0">
                <bic-badge>{{ rule.category }}</bic-badge>
              </div>
            </div>
          }
        }
      </div>
    </div>

    <!-- RIGHT: Selected rules -->
    <div class="flex flex-col h-full w-1/2 gap-3 py-6 border-bic-gray-200 border rounded-lg overflow-hidden">
      <p class="text-gray text-sm px-6 flex-shrink-0 font-medium h-[38px]">Ausgewählte Prüfregeln:</p>
      <div
        #selectedRulesList="cdkDropList"
        (cdkDropListDropped)="drop($event)"
        [cdkDropListConnectedTo]="availableRulesList"
        [cdkDropListData]="selectedRules"
        cdkDropList
        class="flex flex-col flex-grow min-h-0 w-full overflow-y-auto gap-3 py-1 px-6"
        id="selectedRulesList">
        @for (rule of selectedRules; track rule.id) {
          <div cdkDrag
               class="flex flex-row shadow-full w-full rounded-lg justify-between items-center hover:cursor-grab p-4 flex-shrink-0">
            <div class="flex flex-row justify-start items-center gap-4 min-w-0">
              <button (click)="removeRuleFromSelected(rule)" class="flex-shrink-0">
                <fa-icon [icon]="faCircleXmark" class="text-yellow"></fa-icon>
              </button>
              <div class="font-medium text-gray-700 text-sm truncate">{{ rule.name }}</div>
            </div>
            <div class="flex flex-row justify-end items-center gap-4 flex-shrink-0">
              <bic-badge>{{ rule.category }}</bic-badge>
            </div>
          </div>
        }
        @if (availableRules.length > 0) {
          <div
            class="flex-grow min-h-[138px] flex flex-col justify-center items-center bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-6 gap-2">
            <fa-icon [icon]="faSquareDashedCirclePlus" class="text-gray-400 text-[48px]"></fa-icon>
            <div class="text-center text-sm text-gray-500">Prüfregeln per Drag & Drop auswählen</div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Navigation Button centered -->
  <div class="flex justify-center flex-shrink-0 px-6">
    <bic-button (click)="confirm()" [disabled]="selectedRules.length === 0" [loading]="confirming">
      Dateiauswahl
      <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
    </bic-button>
  </div>
</div>
